module.exports = __webpack_public_path__ + "img/thumb_06.4a1418ab.jpg";